module.exports = __webpack_public_path__ + "img/kh2_14.7240683b.png";